import { componentProvider } from 'js-component-framework';
import PrintPowerWords from './print-power-words';

/**
 *
 * @type {{name: string, querySelector: {container: string, button: string},
 *   class: PrintPowerWords}}
 */
const printPowerWordsConfig = {
  name: 'print-power-words',
  component: PrintPowerWords,
  querySelector: {
    sectionContainer: '.power-words-container',
    ppwButton: '.print-power-words-btn',
  },
};

componentProvider(printPowerWordsConfig);
